<template>
  <div class="page-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>
        <span class="page-title">冻结锁仓</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item>锁仓系数</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="page-content" shadow="never">
      <div class="page-actions">
        <create @refresh="getList"></create>
      </div>
      <list @refresh="getList"></list>
    </el-card>
  </div>
</template>

<script>
import './store';
import { mapActions, mapState, mapGetters } from 'vuex';
import List from './components/list';
import Create from './components/create';

export default {
  name: 'c',
  data() {
    return {};
  },
  components: {
    List,
    Create
  },
  computed: {
    ...mapState('pledgeCoefficient', ['pagination']),
    ...mapGetters('pledgeCoefficient', ['list'])
  },
  methods: {
    ...mapActions('pledgeCoefficient', ['reqList']),
    getList(data = {}) {
      this.reqList({
        ...this.pagination,
        ...data
      });
    }
  },
  created() {
    this.getList();
  }
};
</script>

<style lang="less" scoped>
.actions-bar {
  display: flex;
  align-items: center;
}

.el-input {
  width: 300px;
}

.el-date-editor,
.el-input {
  margin-right: 10px;
}
</style>
